module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Book.6365c40a.svg";